module.exports = __webpack_public_path__ + "static/home_hero_image-b3007414412a186aaa697800cfe47a14.jpg";